import { TheatricalShowtime } from '@/types/codegen-federation'

export const getSeatIcon = (available: boolean) =>
  available
    ? 'v1734499261/Tickets/Seat%20Types%20v4/single-01-avail'
    : 'v1734499265/Tickets/Seat%20Types%20v4/single-unavail'

// Transform seatmap data to ReservationSeat format
export const transformSeats = (showtime: TheatricalShowtime) => {
  if (!showtime.seatmap?.seats) return []

  return showtime.seatmap.seats.map((seat, index) => {
    const availableIcon = getSeatIcon(seat.available)

    return {
      __typename: 'ReservationSeat' as const,
      seatId: `${showtime.id}-${seat.x}-${seat.y}-${index}`,
      seatName: `${String.fromCharCode(65 + seat.y)}${seat.x + 1}`,
      isAvailable: seat.available,
      xCoord: seat.x,
      yCoord: seat.y,
      seatType: {
        __typename: 'ReservationSeatType' as const,
        reference: 'STANDARD' as const,
        description: 'Standard',
        icons: {
          __typename: 'ReservationSeatIcons' as const,
          default: {
            __typename: 'ReservationSeatIcon' as const,
            cloudinaryPath: availableIcon,
            url: `https://images.angelstudios.com/image/upload/${availableIcon}.svg`,
          },
          hover: {
            __typename: 'ReservationSeatIcon' as const,
            cloudinaryPath: availableIcon,
            url: `https://images.angelstudios.com/image/upload/${availableIcon}.svg`,
          },
          selected: {
            __typename: 'ReservationSeatIcon' as const,
            cloudinaryPath: availableIcon,
            url: `https://images.angelstudios.com/image/upload/${availableIcon}.svg`,
          },
        },
      },
      rates: [],
      areaCategory: null,
    }
  })
}
